/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { AnalyticsConstants, Operations, Payload } from '@tivocorp/tivo-webapp-loggers';
import { NFREvents } from '../enums';

export class NFRLoggings {
    private static Fields = { ERROR_TYPE: 'errorType' };

    static log(eventName: string, error?: any) {
        const payload = new Payload();
        payload.add(AnalyticsConstants.Fields.REFRENCE_TIME, new Date().getTime());

        switch (eventName) {
            case NFREvents.FAILURE_LOADING_ACTIONS_LIST:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, error?.TAG);
                payload.add(NFRLoggings.Fields.ERROR_TYPE, error?.getType());
                payload.add(AnalyticsConstants.Fields.ERROR_CODE, error?.getCode());
                payload.add(AnalyticsConstants.Fields.MESSAGE, error?.getMessage());
                Operations.log(payload);
                break;

            case NFREvents.FAILURE_LOADING_CHANNELS:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, error?.TAG);
                payload.add(NFRLoggings.Fields.ERROR_TYPE, error?.getType());
                payload.add(AnalyticsConstants.Fields.ERROR_CODE, error?.getCode());
                payload.add(AnalyticsConstants.Fields.MESSAGE, error?.getMessage());
                Operations.logFailureLoadingChannels(payload);

                break;

            case NFREvents.FAILURE_LOADING_GUIDE_ROWS:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, error?.TAG);
                payload.add(NFRLoggings.Fields.ERROR_TYPE, error?.getType());
                payload.add(AnalyticsConstants.Fields.ERROR_CODE, error?.getCode());
                payload.add(AnalyticsConstants.Fields.MESSAGE, error?.getMessage());
                Operations.logFailureLoadingGuideRows(payload);
                break;

            case NFREvents.FAILURE_LOADING_PREVIEW:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, error?.TAG);
                payload.add(NFRLoggings.Fields.ERROR_TYPE, error?.getType());
                payload.add(AnalyticsConstants.Fields.ERROR_CODE, error?.getCode());
                payload.add(AnalyticsConstants.Fields.MESSAGE, error?.getMessage());
                Operations.logFailureLoadingPreview(payload);
                break;

            case NFREvents.FAILURE_LOADING_VOD_OTT_ACTION_DETAILS:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, error?.TAG);
                payload.add(NFRLoggings.Fields.ERROR_TYPE, error?.getType());
                payload.add(AnalyticsConstants.Fields.ERROR_CODE, error?.getCode());
                payload.add(AnalyticsConstants.Fields.MESSAGE, error?.getMessage());
                Operations.log(payload);
                break;

            case NFREvents.FINISH_LOADING_ACTIONS_LIST:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, eventName);
                Operations.log(payload);
                break;

            case NFREvents.FINISH_LOADING_CHANNELS:
                Operations.logFinishLoadingChannels(payload);
                break;

            case NFREvents.FINISH_LOADING_GUIDE:
                Operations.logFinishLoadingGuide(payload);
                break;

            case NFREvents.FINISH_LOADING_GUIDE_ROWS:
                Operations.logFinishLoadingGuideRows(payload);
                break;

            case NFREvents.FINISH_LOADING_PREVIEW:
                Operations.logFinishLoadingPreview(payload);
                break;

            case NFREvents.FINISH_LOADING_VOD_OTT_ACTION_DETAILS:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, eventName);
                payload.add(
                    AnalyticsConstants.Fields.LOG_TYPE,
                    AnalyticsConstants.LogTypes.OPERATIONS,
                );
                Operations.log(payload);
                break;

            case NFREvents.START_LOADING_ACTIONS_LIST:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, eventName);
                Operations.log(payload);
                break;

            case NFREvents.START_LOADING_CHANNELS:
                Operations.logStartLoadingChannels(payload);
                break;

            case NFREvents.START_LOADING_GUIDE:
                Operations.logStartLoadingGuide(payload);
                break;

            case NFREvents.START_LOADING_GUIDE_ROWS:
                Operations.logStartLoadingGuideRows(payload);
                break;

            case NFREvents.START_LOADING_PREVIEW:
                Operations.logStartLoadingPreviews(payload);
                break;

            case NFREvents.START_LOADING_VOD_OTT_ACTION_DETAILS:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, eventName);
                payload.add(
                    AnalyticsConstants.Fields.LOG_TYPE,
                    AnalyticsConstants.LogTypes.OPERATIONS,
                );
                Operations.log(payload);
                break;

            default:
                payload.add(AnalyticsConstants.Fields.EVENT_NAME, eventName);
                Operations.log(payload);
        }
    }
}
